import type { ReactNode } from "react";

import { ConfirmationModal as UIKitConfirmationModal } from "@/react/components/shared/ModalsV2/ConfirmationModal";
import type { ConfirmationModalProps as UIKitConfirmationModalProps } from "@/react/components/shared/ModalsV2/ConfirmationModal";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { CompassConfirmationModal } from "./CompassConfirmationModal";

export interface ConfirmationModalProps extends UIKitConfirmationModalProps {
  /**
   * Temporarily overrides children only in Compass; nullish values fall back to
   * ordinary children, which UIKit always receives. Remove when UIKit routing is removed.
   */
  compassChildren?: ReactNode;
}

export const ConfirmationModal = ({
  compassChildren,
  ...props
}: ConfirmationModalProps) => {
  // eslint-disable-next-line no-restricted-syntax -- Temporary feature flag retains UIKit routing until its implementation is removed.
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (isCircleV4) {
    const {
      cancelText,
      children,
      confirmText,
      confirmVariant,
      disabled: isDisabled,
      loading: isLoading,
      formId,
      isOpen,
      onCancel,
      onClose,
      onConfirm,
      size,
      title,
      dataTestId,
    } = props;

    return (
      <CompassConfirmationModal
        cancelText={cancelText}
        confirmText={confirmText}
        confirmVariant={confirmVariant}
        disabled={isDisabled}
        loading={isLoading}
        formId={formId}
        isOpen={isOpen}
        onCancel={onCancel}
        onClose={onClose}
        onConfirm={onConfirm}
        size={size}
        title={title}
        dataTestId={dataTestId}
      >
        {compassChildren ?? children}
      </CompassConfirmationModal>
    );
  }

  return <UIKitConfirmationModal {...props} />;
};
